/* eslint-disable import/no-named-as-default */
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import {DFPManager, AdSlot} from 'react-dfp';
import axios from 'axios';
import HomePage from './HomePage';
import Race from './Race';
import MobileSearch from './MobileSearch';
import MobileRaceHome from './MobileRaceHome';
import MobileResults from './MobileResults';
import MobileDivisionResults from './MobileDivisionResults';
import Favorites from './Favorites';
import Unathorized from './Unauthorized';
import Runner from './Runner';
import NotFoundPage from './NotFoundPage';
import Loading from './Loading';
import {setIsMobile, addAPIKeyToHeader} from '../actions/race';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

const MOBILE_WIDTH = 500;

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      isMobile: false, //window.innerWidth < MOBILE_WIDTH,
      houseAd: null,
      houseAdCounter: 0
    };

    this.handleWindowSizeChange(true, props);
  }

  houseAdInterval = null;
  adsenseAdInterval = null;

  componentWillUpdate(newProps) {
    // if (this.state.isMobile !== newProps.isMobile) {
    //   this.setState({isMobile: newProps.isMobile});
    // }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange.bind(this));
    window.addEventListener('orientationchange', this.handleWindowSizeChange.bind(this));



    // window.setInterval(function refreshAds() { DFPManager.refresh(); }, 15000);
    //
    // DFPManager.load();

    // const isMobile = this.state.width < MOBILE_WIDTH;

    const _this = this;

    if (this.props.ads && this.props.ads.type === 'adsense') {

      this.adsenseAdInterval = setInterval(() => {

        // console.log('Calling Refresh');
        DFPManager.refresh();

      }, 30000);


    } else if (this.props.ads && this.props.ads.showMobile && this.props.ads.type === 'house') {

      this.fetchHouseAd();

      this.houseAdInterval = setInterval(() => {
        _this.fetchHouseAd();
      }, 30000);

    }



  }

  fetchHouseAd() {
    const _this = this;

    if (this.props.accountId && this.state.width < MOBILE_WIDTH) {
      axios.get('https://api.v2.raceresults360.com/v2/ad/random', addAPIKeyToHeader(() => {return {rr360: {accountId: this.props.accountId}}; }))
        .then((result) => {
          _this.setState({houseAd: result.data});
        })
    }
  }

// make sure to remove the listener
// when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange.bind(this));
    window.removeEventListener('orientationchange', this.handleWindowSizeChange.bind(this));

    if (this.adsenseAdInterval) {
      clearInterval(this.adsenseAdInterval);
    }
    if (this.houseAdInterval) {
      clearInterval(this.houseAdInterval);
    }
  }

  handleWindowSizeChange(initial = false, props = null){

    // const _this = this;
    //
    // setTimeout(() => {
    //
    //   if (!initial) {
    //     this.setState({width: window.innerWidth}); //, isMobile: window.innerWidth <= MOBILE_WIDTH});
    //   }
    //   const leProps = props || this.props;
    //
    //   if (window.innerWidth <= MOBILE_WIDTH !== leProps.isMobile) {
    //
    //     // console.log(window.innerWidth);
    //
    //     leProps.setIsMobile(window.innerWidth <= MOBILE_WIDTH);
    //   } else if (window.innerWidth > MOBILE_WIDTH && leProps.isMobile) {
    //
    //     leProps.setIsMobile(window.innerWidth <= MOBILE_WIDTH);
    //   }
    // }, 200);
  }

  componentDidMount() {
    const elem = document.querySelector('base');
    if (elem) {
      elem.setAttribute('href', document.location.origin + document.location.pathname);
    }

  }

  renderBodyWithRoutes() {
    return (
      <div className="body">
        <Switch>
          <Route exact path="/race/a6aJJz//612" render={() => <Redirect to="/race/a6aJJz/" />} />
          <Route exact path="/" component={HomePage}/>
          <Route exact path="/race/:raceId" component={Race}/>
          <Route exact path="/race/:raceId/" component={Race}/>
          <Route exact path="/race/:raceId//" render={(props) => <Race noEvent {...props} />}/>
          <Route exact path="/race/:raceId//search" render={(props) => <Race noEvent {...props} />}/>
          <Route exact path="/race/:raceId//results" render={(props) => <Race noEvent selectedTab="results" {...props} />}/>
          <Route exact path="/race/:raceId//results/:division" render={(props) => <Race noEvent selectedTab="searchResults" {...props} />}/>
          <Route exact path="/race/:raceId//favorites" render={(props) => <Race noEvent selectedTab="favorites" {...props} />}/>
          <Route exact path="/race/:raceId//questions" render={(props) => <Race noEvent selectedTab="questions" {...props} />}/>
          <Route exact path="/race/:raceId/search" component={Race}/>
          <Route exact path="/race/:raceId/results" render={(props) => <Race selectedTab="results" {...props} />}/>
          <Route exact path="/race/:raceId/results/:division" render={(props) => <Race selectedTab="searchResults" {...props} />}/>
          <Route exact path="/race/:raceId/favorites" render={(props) => <Race selectedTab="favorites" {...props} />}/>
          <Route exact path="/race/:raceId/questions" render={(props) => <Race selectedTab="questions" {...props} />}/>


          <Route exact path="/race/:raceId/:eventId" component={Race}/>
          <Route exact path="/race/:raceId/:eventId/" component={Race}/>
          <Route exact path="/race/:raceId/:eventId/search" component={Race}/>
          <Route exact path="/race/:raceId/:eventId/results" render={(props) => <Race selectedTab="results" {...props} />}/>
          <Route exact path="/race/:raceId/:eventId/results/:division" render={(props) => <Race selectedTab="searchResults" {...props} />}/>
          <Route exact path="/race/:raceId/:eventId/favorites" render={(props) => <Race selectedTab="favorites" {...props} />}/>
          <Route exact path="/race/:raceId/:eventId/questions" render={(props) => <Race selectedTab="questions" {...props} />}/>

          <Route exact path="/race/:raceId/:eventId/:bib" component={Runner}/>
          <Route exact path="/race/:raceId//:bib" component={Runner}/>
          <Route component={NotFoundPage} />
        </Switch>
      </div>
    )
  }


  handleMobileBodyScroll(e) {
    // console.log(e.target.scrollTop);
    // console.log(e.target.scrollHeight);
    //
    if (!this.state.scrollShowMore && (e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight - 45 * 10)) {
      // console.log('Yo!');
      this.setState({scrollShowMore: true});
    }
  }

  resetScrollShowMore() {
    const _this = this;
    setTimeout(() => {
      // console.log('Reset!');
      _this.setState({scrollShowMore: false});
    }, 1000);
  }

  render() {

    if (!this.props.accountId) {
      return (
        <Loading />
      );
    }

    if (this.props.unauthorized){
      return (
        <Unathorized />
      );
    }

    return this.renderBodyWithRoutes();

  }
}

App.propTypes = {
  children: PropTypes.element
};

function mapStateToProps(state) {
  return {
    isMobile: state.rr360.isMobile,
    ads: state.rr360.ads,
    brand: state.rr360.brand,
    accountId: state.rr360.accountId,
    theme: state.rr360.theme,
    singleEvent: state.rr360.singleEvent,
    unauthorized: state.rr360.unauthorized
  };
}


export default withRouter(connect(mapStateToProps, {setIsMobile})(App));



// WEBPACK FOOTER //
// ./src/components/App.js